import React from 'react';
import { useParams } from 'react-router-dom';
import { StyleSheet, Text, View } from './components/base_components';
import Breadcrumb from './components/breadcrumb';
import StandardBoxList from './components/standard_box_list';
import TitleActionLine from './components/title_action_line';
import VolumeTabBar from './components/volume_tab_bar';

import AuditStore from './stores/audit_store';
import MediaGrantAdminStore from './stores/media_grant_admin_store';
import UserStore from './stores/user_store';
import VolumeStore from './stores/volume_store';

import { dateFormat } from './tools/util';

const styles = StyleSheet.create({
  volumeAuditScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  tabBar: {
    marginLeft: '2rem',
    marginRight: '2rem',
  },
  emptyListText: {
    margin: '2rem',
    color: '#666',
    fontSize: '1.5rem',
  },
});
export default function VolumeAuditScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const org_id = org?.org_id;
  const volume_id = parseInt(params.volume_id ?? '0', 10) || 0;
  const volume = VolumeStore.useVolume(org_id, volume_id);
  const audit_list = AuditStore.useVolumeList(volume_id);
  const grant_list = MediaGrantAdminStore.useList(org_id);

  React.useEffect(() => {
    VolumeStore.fetch(org_id);
    MediaGrantAdminStore.fetch(org_id);
  }, [org_id]);
  React.useEffect(() => {
    AuditStore.fetchVolume({ volume_id, org_id });
  }, [org_id, volume_id]);

  const rows = audit_list?.map?.((item) => {
    let list = [dateFormat(item.create_time)];
    const url = _makeUrl(grant_list, volume_id, item.media_path);
    if (
      item.device_id &&
      item.user_id &&
      item.media_path === 'volume_encryption_key'
    ) {
      list.push(
        item.user_name || item.email,
        'Device: ' + item.device_name,
        'Volume Key Download'
      );
    } else if (!item.dest_path) {
      list.push(
        item.device_name || item.user_name || item.email,
        item.media_path,
        'Web Download'
      );
    } else {
      list.push(
        item.device_name || item.user_name || item.email,
        item.media_path,
        item.dest_path
      );
    }
    return { url, list };
  });
  return (
    <View style={styles.volumeAuditScreen}>
      <Breadcrumb
        list={[
          { text: 'Volumes', url: '/volume' },
          { text: volume?.volume_name, url: `/volume/${volume_id}` },
          'Audit',
        ]}
      />
      <TitleActionLine title={volume?.volume_name} />
      <VolumeTabBar style={styles.tabBar} volumeId={volume_id} />
      <StandardBoxList
        title='Audit Tracking'
        detail={audit_list?.length ?? 0}
        headers={['Timestamp', 'User', 'Source', 'Destination']}
        sizes={[1, 2, 3, 3]}
        linkColumn={2}
        rows={rows}
      >
        {audit_list?.length === 0 ? (
          <Text style={styles.emptyListText}>No audit events found.</Text>
        ) : null}
      </StandardBoxList>
    </View>
  );
}
function _makeUrl(list, volume_id, path) {
  const found = list
    ?.filter?.(
      (grant) =>
        grant.volume_id === volume_id && path.startsWith(grant.prefix_path)
    )
    ?.sort?.(_sortPrefixLen)?.[0];

  let ret = '';
  if (found) {
    const grant_path = path.slice(found.prefix_path.length);
    ret = `/home/${found.grant_name}/${grant_path}`;
  }
  return ret;
}
function _sortPrefixLen(a, b) {
  return a.prefix_path.length - b.prefix_path.length;
}
